import { jsx as _jsx, jsxs as _jsxs } from "nativewind/jsx-runtime";
import React from 'react';
import { View } from 'react-native';
import ChallengeDetailQuestSection from '../ChallengeDetailQuestSection';
import LastMonthRankingSection from './LastMonthRankingSection';
import MyRank from './MyRank';
import TopTenRank from './TopTenRank';
const ChallengeDetailRankSection = ({ ranks, myRank, quests, lastMonthRankImageUrl, }) => {
    const hasContent = (ranks && ranks.length > 0) ||
        myRank ||
        (quests && quests.length > 0) ||
        lastMonthRankImageUrl;
    if (!hasContent) {
        return null;
    }
    return (_jsxs(View, { className: "w-full bg-white", children: [_jsx(View, { className: "h-[6px] bg-gray-v2-15" }), _jsxs(View, { className: "py-[32px] gap-[44px]", children: [quests && (quests === null || quests === void 0 ? void 0 : quests.length) > 0 && (_jsx(ChallengeDetailQuestSection, { quests: quests })), myRank && _jsx(MyRank, { myRank: myRank }), ranks && ranks.length > 0 && _jsx(TopTenRank, { ranks: ranks }), lastMonthRankImageUrl && (_jsx(LastMonthRankingSection, { imageUrl: lastMonthRankImageUrl }))] })] }));
};
export default ChallengeDetailRankSection;
